import api from './api';

const supportRequestService = {
  getRequests: async (params = {}) => {
    const response = await api.get('/admin/support/requests', { params });
    return response.data.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/admin/support/requests/${id}/status`, {
      status,
    });
    return response.data.data;
  },
};

export default supportRequestService;

